import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import edit from "../../../assets/images/edit.png";
import trash from "../../../assets/images/trash.png";
import BellR from "../../../assets/images/bell_de.png";
import BellG from "../../../assets/images/bell_flt.png";
import MailR from "../../../assets/images/mail_dlt.png";
import MailG from "../../../assets/images/mail_at.png";
import Userview from "../../../assets/images/useer_view.png";
import Select from 'react-select';
import { toast } from 'react-toastify';

import ConfModal from '../../../Components/common/ConfModal.js';
import { CallApi } from '../../../Components/common/CommonFunctions.js';

const DepartmentSettings = ({ isModal, ruleId }) => {

  const isMounted = useRef(false);
  const [modalShow, setModalShow] = useState(false);
  const [editId, setEditId] = useState('');
  const [deleteId, setDeleteId] = useState('');
  const [modalConf, setModalConf] = useState(false);
  const [deleteFunction, setDeleteFunction] = useState(null);
  const userRole = [
    { label: 'User', value: 'E' },
    { label: 'Admin', value: 'S' },
    // {label: 'Company Super Admin', value: 'SA'}
  ];
  const taskType = [
    { label: "Custom", value: "Custom" },
    { label: "Finding", value: "Finding" },
    { label: "Finding (minor)", value: "Finding (minor)" },
    { label: "Finding (Major)", value: "Finding (Major)" },
    { label: "Observation", value: "Observation" },
    { label: "Observation (minor)", value: "Observation (minor)" },
    { label: "Observation (Major)", value: "Observation (Major)" },
    { label: "Improvement opportunity", value: "Improvement opportunity" }
  ];
  const handleAddButtonClick = () => {
    setModalShow(true);
  };
 
  const handleModalClose = () => {
    setModalShow(false);
    setFormData({});
    setEditId('');

  };

  const [gridData, setGridData] = useState([]);
  const [userList, setUserList] = useState([]);
  const fetchuser = async () => {
    CallApi({
      endPoint: 'uld-setting/get-user-list',
      payload: { status: 'A' },
      onSuccess: (data) => {
        const innerData = data.data.Rows;

        const transformData = innerData ? innerData.map((item) => ({
          label: item.first_name + ' ' + item.last_name,
          value: item.user_id
        })) : []
        setUserList(transformData)
      },
      onError: (msg) => toast.error(msg)
    });
  };
  const fetchData = () => {
    CallApi({
      endPoint: 'organisation-department/list',
      method: 'get',
      onSuccess: (data) => {
        const innerData = data.data.Rows;

        setGridData(innerData);
      },
      onError: (msg) => toast.error(msg)
    });
  };
  useEffect(() => {
    if (isMounted.current) return;
    // Call the fetchData function to fetch data from the API
    fetchData();
    fetchuser();
    isMounted.current = true;
  }, []);

  // const fetchDataDetails = async (id) => {
  //   try {
  //     const res = await withRFSToken.post(USERDETAILS, { user_id: id })
  //       .then(function (res) {
  //         const innerData = res.data.data;
  //         console.log("🚀 ~ .then ~ innerData:xxx", innerData)
  //         const userId = innerData.user_id;

  //         const portalAccess = innerData.portal_access;
  //         const portalAccessObject = {};
  //         if (portalAccess) {
  //           portalAccess.forEach((key) => {
  //             portalAccessObject[key] = true;
  //           });
  //           setFormData({
  //             ...innerData,
  //             station_code: innerData.port_code,
  //             portal_access: portalAccessObject
  //           });
  //           handleEditButtonClick(userId);
  //           console.log("🚀 ~ .then ~ portalAccessObject:", portalAccessObject)
  //         }

  //         return portalAccessObject;
  //         // const transformedData = innerData ? innerData.map(item => ({
  //         //   value: item.code,
  //         //   label: item.code +'-'+ item.name
  //         // })) : [];    
  //         // setStationList(innerData);
  //       });

  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };
  const gridRef = useRef(null);
  useEffect(() => {
    // console.log("🚀 ~ ExportActive ~ PPP:", gridData)
    if (gridRef.current) {

      const source = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'string' },
          { name: 'department_name', type: 'string' },
          { name: 'organization', type: 'string' },
          { name: 'updated_by', type: 'string' },
          { name: 'created_by', type: 'string' },
          { name: 'created_on', type: 'string' },
          { name: 'chief_user_id', type: 'string' },
        ],
        localdata: gridData,
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);

      const columns = [
        {
          text: 'Actions',
          filterable: false,
          cellsrenderer: function () {
            return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /><img src="' + trash + '" class="row_delete" /></div>';
          },
          width: '12%'
        },
        { text: 'Department name', filtertype: 'textbox', datafield: 'department_name', width: '25%', cellclassname: '', },
        { text: 'Organization', filtertype: 'textbox', datafield: 'organization', width: '22%', cellclassname: '', },
        // { text: 'User Assigned', filtertype: 'textbox', datafield: 'organization', width: '22%', cellclassname: '', },
        // { text: 'Updated By', filtertype: 'textbox', datafield: 'updated_by', width: '18%', cellclassname: '', },
        // { text: 'Created By', filtertype: 'textbox', datafield: 'created_by', width: '20%', cellclassname: '', },
        // { text: 'Created Date', filtertype: 'textbox', datafield: 'created_on', width: '10%', cellclassname: '', },
      ];


      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: true,
        sortable: true,
        altrows: false,
        enabletooltips: true,
        editable: false,
        // selectionmode: 'checkbox',
        pageable: true,
        pageSize: 10,
        pagerButtonsCount: 10,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 50,
        columnsheight: 45,
      };

      window.$(gridRef.current).jqxGrid(gridOptions);
      window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

      window.$(gridRef.current).on('click', '.row_edit', function (row) {

        const rowDiv = window.$(this).closest('[role="row"]');

        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
        const id = rowData.id;
        console.log('Row Data:', rowData);
        setEditId(id);
        setModalShow(true);
        setFormData({
          id: rowData.id || '',
          department_name: rowData.department_name || '',
          chief_user_id: rowData.chief_user_id || '',

        });
      });
      window.$(gridRef.current).on('click', '.row_delete', function (row) {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const boundIndex = window.$(gridRef.current).jqxGrid('getrowid', rowIndex);
        if (boundIndex !== undefined) {
          const pagingInfo = window.$(gridRef.current).jqxGrid('getpaginginformation');
          const pageIndex = pagingInfo.pagenum;
          const pageSize = pagingInfo.pagesize;
          const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;

          const rowData = window.$(gridRef.current).jqxGrid('getrowdata', globalIndex);
          if (rowData) {
            // console.log('Row Data:', rowData);
            setDeleteId(rowData.id);
            setModalConf(true)
          } else {
            console.error('No data found for the given row index.');
          }
        } else {
          console.error('Bound index could not be retrieved. Check the row index and data binding.');
        }

      });

    }

  }, [gridData]);

  const [formData, setFormData] = useState({
    task_type: 'gfsdsfdg'
  });

  const handleChange = (name, value) => {
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleConfirmDelete = () => {
    deleteRow();
    setModalConf(false);

  };

  const handleCancelDelete = () => {
    setDeleteId('')
    setModalConf(false);
  };
  const deleteRow = (selectedId) => {
    CallApi({
      endPoint: 'organisation-department/delete-restore',
      payload: { id: deleteId },
      onSuccess: (data) => {
        if (data.data.response_code === 200) {
          toast.success('Department Removed Successfully')
          fetchData();
          setDeleteId('');
        } else {
          toast.error(data.response_msg);
        }
      },
      onError: (msg) => toast.error(msg)
    });
  };

  const handleEditSave = async () => {
    if (!formData.department_name) {
      toast.error('Department Name must not be blank');
      return;
    }
    CallApi({
      endPoint: 'organisation-department/add-update',
      payload: formData,
      onSuccess: (data) => {
        if (data.data.response_code === 200) {
          fetchData();
          toast.success(data.data.response_msg)
          setModalShow(false)
        } else {
          toast.error(data.response_msg);
        }
      },
      onError: (msg) => toast.error(msg)
    });
  }

  const SBack = localStorage.getItem('SettingsBack');

  return (
    <>
      {/* <div className="">{console.log('delete id ', deleteId)}
        <Header logo_url={SBack ? SBack : '/ServiceRecovery'} />
        <div className="main-panel">

          <div className="row">
            <LeftSettings /> */}
      {modalConf &&
        <ConfModal
          header='Confirm Delete'
          subHeader='If you proceed with the change, Template data will be removed. Are you sure you want to continue?'
          modalConf={handleConfirmDelete}
          closeModal={handleCancelDelete}
          primaryBtn='Yes'
          secondaryBtn='No'
        />
      }
      <div className='col-9 col-xxl-9 stting_right'>
        <div className='settingbg_right'>
          <h4>Department Settings</h4>
          <p>Lorem ipsum dolor sit amet, consectetur</p>
          <div className='d-flex justify-content-between'>
            <div>
              <Button variant="primary createplan" onClick={handleAddButtonClick} >
                <FontAwesomeIcon icon={faPlus} /> Add Department
              </Button>
            </div>
          </div>
          <div ref={gridRef} className='bookinggrid userstting'></div>
          {/* </div> */}
        </div>
      </div>
      <Modal show={modalShow} centered onHide={handleModalClose} className='addfrom' >
        <Modal.Header closeButton>
          <Modal.Title>
            {editId &&
              !editId == '' ? (
              <>
                Edit Department
              </>
            ) : (
              <>
                Add Department
              </>
            )
            }
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row} className='mb-2'>
            <Col sm="12">
              <Form.Label>Department name <span className='text-danger'>*</span></Form.Label>
              <Form.Control type="text" name='department_name' placeholder="Add Department Name" value={formData.department_name} onChange={(e) => handleChange('department_name', e.target.value)} />
            </Col>
          </Form.Group>

          <Form.Group controlId="dropdown" className='mb-3' as={Row}>
            <Col sm='12'>
              <Form.Label>Chief(optional)</Form.Label>
              <Select
                options={userList}
                onChange={selected => setFormData({ ...formData, chief_user_id: selected ? selected.value : '' })}
                placeholder="Select Chief"
                className='down_selct'
                name="chief_user_id"
                value={userList.find(option => option.value === formData.chief_user_id) || null}
                isClearable
              />
            </Col>
          </Form.Group>


        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-50 mx-auto are_bottom'>
            <Button variant="secondary" onClick={() => setModalShow(false)}>
              Discard
            </Button>
            <Button variant="primary" onClick={handleEditSave}>
              Save
            </Button>
          </div>


        </Modal.Footer>
      </Modal>
    </>
  )
}

export default DepartmentSettings;